<div class="chat-composer" [class.chat-composer--note]="isNote">

  <div class="chat-composer__wrap">

    <!-- Respostas rápidas: lista ancorada por cima do compositor -->
    <div *ngIf="quickOpen" class="chat-composer__quick" role="listbox" [attr.aria-label]="strings.quickReplies">
      <p *ngIf="quickFiltered.length === 0" class="chat-composer__quick-empty">
        {{ (quickReplies || []).length === 0 ? strings.quickRepliesEmpty : strings.quickNoMatch }}
      </p>
      <button *ngFor="let r of quickFiltered; let i = index; trackBy: trackByQuick" type="button" role="option"
        class="chat-composer__quick-item" [class.chat-composer__quick-item--on]="i === quickIndex"
        [attr.aria-selected]="i === quickIndex" (mousedown)="$event.preventDefault()" (click)="pickQuick(r)">
        <span class="chat-composer__quick-key">{{ r.shortcut }}</span>
        <span class="chat-composer__quick-text">{{ r.message }}</span>
      </button>
    </div>

    <!-- Menções (7.1): lista de colegas ancorada por cima do compositor, em modo nota -->
    <div *ngIf="mentionOpen" class="chat-composer__quick" role="listbox" [attr.aria-label]="strings.mentionsLabel">
      <button *ngFor="let m of mentionFiltered; let i = index; trackBy: trackByMention" type="button" role="option"
        class="chat-composer__quick-item" [class.chat-composer__quick-item--on]="i === mentionIndex" [attr.aria-selected]="i === mentionIndex"
        (mousedown)="$event.preventDefault()" (click)="pickMention(m)">
        <span class="chat-composer__quick-key">@</span>
        <span class="chat-composer__quick-text">{{ m.name }}</span>
      </button>
    </div>

    <!-- Barra de ferramentas -->
    <div class="chat-composer__toolbar">
      <input #file type="file" class="chat-sr-only" multiple [accept]="accept" (change)="onFiles($event)" tabindex="-1" aria-hidden="true">
      <input #imageFile type="file" class="chat-sr-only" multiple [accept]="acceptImages" (change)="onFiles($event)" tabindex="-1" aria-hidden="true">

      <span class="chat-composer__anchor">
        <button type="button" class="chat-composer__tool" [class.chat-composer__tool--on]="emojiOpen" [attr.aria-label]="strings.emoji"
          [attr.aria-expanded]="emojiOpen" [ngbTooltip]="strings.emoji" container="body" (click)="toggleEmoji()">
          <chat-icon name="smile" [size]="18"></chat-icon>
        </button>
        <chat-emoji-picker *ngIf="emojiOpen" class="chat-composer__emoji" [labels]="emojiLabels" storageKey="imodigi-chat-emoji-recent"
          (pick)="insertEmoji($event)" (close)="closeEmoji()"></chat-emoji-picker>
      </span>

      <button type="button" class="chat-composer__tool" [attr.aria-label]="strings.attach" [ngbTooltip]="strings.attach" container="body"
        [disabled]="isNote || !!editing" (click)="file.click()">
        <chat-icon name="clip" [size]="18"></chat-icon>
      </button>
      <button *ngIf="canSuggestProperties" type="button" class="chat-composer__tool" [attr.aria-label]="strings.sendProperty"
        [ngbTooltip]="strings.sendProperty" container="body" [disabled]="isNote || !!editing" (click)="suggestProperty.emit()">
        <chat-icon name="home" [size]="18"></chat-icon>
      </button>
      <button type="button" class="chat-composer__tool" [attr.aria-label]="strings.sendImage" [ngbTooltip]="strings.sendImage" container="body"
        [disabled]="isNote || !!editing" (click)="imageFile.click()">
        <chat-icon name="image" [size]="18"></chat-icon>
      </button>
      <button type="button" class="chat-composer__tool" [class.chat-composer__tool--on]="quickOpen" [attr.aria-label]="strings.quickReplies"
        [attr.aria-expanded]="quickOpen" [ngbTooltip]="strings.quickReplies" container="body" (click)="toggleQuick()">
        <chat-icon name="bolt" [size]="18"></chat-icon>
      </button>
      <span *ngIf="actions.length > 0 && !isNote && !editing" class="chat-composer__anchor">
        <button type="button" class="chat-composer__tool chat-composer__tool--plus" [class.chat-composer__tool--on]="actionsOpen"
          [attr.aria-label]="strings.moreActions" [attr.aria-expanded]="actionsOpen" aria-haspopup="menu" [ngbTooltip]="strings.moreActions"
          container="body" (click)="toggleActions()">
          <chat-icon name="plus" [size]="18"></chat-icon>
        </button>
        <div *ngIf="actionsOpen" class="chat-composer__menu" role="menu">
          <button *ngFor="let a of actions; trackBy: trackByAction" type="button" role="menuitem" class="chat-composer__menu-item"
            (mousedown)="$event.preventDefault()" (click)="pickAction(a)">
            <chat-icon [name]="a.icon" [size]="15"></chat-icon>{{ a.label }}
          </button>
        </div>
      </span>

      <ng-container *ngIf="canWriteNotes">
        <span class="chat-composer__sep" aria-hidden="true"></span>
        <button type="button" class="chat-composer__tool chat-composer__tool--note" [class.chat-composer__tool--note-on]="isNote"
          [attr.aria-label]="strings.tabNote" [attr.aria-pressed]="isNote" [ngbTooltip]="isNote ? strings.exitNoteMode : strings.tabNote"
          container="body" [disabled]="!!editing" (click)="toggleNote()">
          <chat-icon name="note" [size]="18"></chat-icon>
        </button>
        <span *ngIf="isNote" class="chat-composer__note-flag" role="status">
          {{ strings.noteVisibility }}
          <button type="button" class="chat-composer__note-exit" [attr.aria-label]="strings.exitNoteMode" (click)="setMode('reply')">
            <chat-icon name="close" [size]="11"></chat-icon>
          </button>
        </span>
      </ng-container>

      <span *ngIf="remaining <= counterFrom" class="chat-composer__counter" [class.chat-composer__counter--warn]="remaining <= 20"
        role="status" [attr.aria-label]="counterLabel">{{ remaining }}</span>
    </div>

    <!-- Anexos por enviar -->
    <div *ngIf="attachments.length > 0" class="chat-composer__files" role="list" [attr.aria-label]="attachmentsLabel">
      <div *ngFor="let a of attachments; let i = index; trackBy: trackByAttachment" class="chat-composer__file" role="listitem"
        [class.chat-composer__file--doc]="!a.image">
        <img *ngIf="a.image && a.preview" class="chat-composer__file-img" [src]="a.preview" alt="">
        <span *ngIf="!a.image || !a.preview" class="chat-composer__file-icon"><chat-icon [name]="a.image ? 'image' : 'file'" [size]="18"></chat-icon></span>
        <span class="chat-composer__file-name" [title]="a.file.name">{{ a.file.name }}</span>
        <button type="button" class="chat-composer__file-remove" [attr.aria-label]="strings.removeAttachment" (click)="removeAttachment(i)">
          <chat-icon name="close" [size]="11"></chat-icon>
        </button>
      </div>
    </div>

    <!-- Secção 9: a editar uma mensagem (como no WhatsApp) -->
    <div *ngIf="editing" class="chat-composer__editing" role="status">
      <chat-icon name="edit" [size]="15"></chat-icon>
      <span class="chat-composer__editing-text">
        <strong>{{ strings.editingMessage }}</strong>
        <span>{{ editing.message }}</span>
      </span>
      <button type="button" class="chat-composer__editing-x" [attr.aria-label]="strings.cancelEdit" [ngbTooltip]="strings.cancelEdit"
        container="body" (click)="editCancel.emit()">
        <chat-icon name="close" [size]="12"></chat-icon>
      </button>
    </div>

    <!-- Secção 12: as mensagens agendadas pelo próprio nesta conversa -->
    <div *ngIf="scheduled.length > 0" class="chat-composer__scheduled" role="status">
      <div class="chat-composer__scheduled-title"><chat-icon name="clock" [size]="13"></chat-icon>{{ scheduledTitle }}</div>
      <div *ngFor="let s of scheduled; trackBy: trackByScheduled" class="chat-composer__scheduled-item">
        <span class="chat-composer__scheduled-text" [class.chat-composer__scheduled-text--note]="s.kind === 'note'">{{ s.message }}</span>
        <span class="chat-composer__scheduled-when">{{ scheduledWhen(s) }}</span>
        <button type="button" class="chat-composer__editing-x" [attr.aria-label]="strings.cancelScheduled" [ngbTooltip]="strings.cancelScheduled"
          container="body" (click)="cancelScheduled.emit(s.id)">
          <chat-icon name="close" [size]="12"></chat-icon>
        </button>
      </div>
    </div>

    <!-- Campo -->
    <form class="chat-composer__box" [class.chat-composer__box--reply]="replyingTo && !editing" (submit)="submit($event)">
      <!-- Secção 10: a citação dentro do campo, igual à da bolha (como no WhatsApp) -->
      <div *ngIf="replyingTo && !editing" class="chat-composer__reply" role="status"
        [attr.aria-label]="strings.replyingTo.replace('{name}', replyName)">
        <span class="chat-composer__reply-name">{{ replyName }}</span>
        <span class="chat-composer__reply-text">{{ replySnippet }}</span>
        <button type="button" class="chat-composer__reply-x" [attr.aria-label]="strings.cancelReply" [ngbTooltip]="strings.cancelReply"
          container="body" (click)="replyCancel.emit()">
          <chat-icon name="close" [size]="11"></chat-icon>
        </button>
      </div>
      <label class="chat-sr-only" for="chat-composer-input">{{ placeholder }}</label>
      <textarea #input id="chat-composer-input" rows="1" class="chat-composer__input" autocomplete="off" enterkeyhint="send" [class.chat-sr-only]="recording"
        [placeholder]="placeholder" [attr.maxlength]="maxLength" (input)="onInput()" (keydown)="onKeydown($event)"></textarea>
      <!-- mensagem de voz: a gravar, o campo dá lugar ao cronómetro -->
      <div *ngIf="recording" class="chat-composer__recording" role="status" aria-live="polite">
        <span class="chat-composer__rec-dot" aria-hidden="true"></span>
        <span class="chat-composer__rec-text">{{ strings.recording }}</span>
        <span class="chat-composer__rec-time">{{ recordTime }}</span>
        <button type="button" class="chat-composer__rec-btn" [attr.aria-label]="strings.cancelRecording" [ngbTooltip]="strings.cancelRecording"
          container="body" (click)="stopRecording(false)">
          <chat-icon name="trash" [size]="15"></chat-icon>
        </button>
      </div>
      <!-- Secção 12: enviar mais tarde (relógio ao lado do enviar) -->
      <span *ngIf="canScheduleNow" class="chat-composer__anchor">
        <button type="button" class="chat-composer__tool chat-composer__tool--schedule" [class.chat-composer__tool--on]="scheduleOpen"
          [attr.aria-label]="strings.scheduleSend" [ngbTooltip]="strings.scheduleSend" container="body" aria-haspopup="menu" [attr.aria-expanded]="scheduleOpen"
          (click)="toggleSchedule($event)">
          <chat-icon name="clock" [size]="18"></chat-icon>
        </button>
        <div *ngIf="scheduleOpen" class="chat-composer__menu chat-composer__menu--schedule" role="menu" (click)="$event.stopPropagation()">
          <div class="chat-composer__menu-title">{{ strings.scheduleTitle }}</div>
          <button *ngFor="let p of schedulePicks" type="button" role="menuitem" class="chat-composer__menu-item" (mousedown)="$event.preventDefault()"
            (click)="pickSchedule(p)">
            <chat-icon name="clock" [size]="15"></chat-icon>{{ p.label }}
          </button>
          <div class="chat-composer__menu-custom">
            <span class="chat-composer__menu-label">{{ strings.scheduleCustom }}</span>
            <div class="chat-composer__menu-row">
              <input type="date" class="form-control form-control-sm" [attr.aria-label]="strings.dateLabel" [(ngModel)]="scheduleDate">
              <input type="time" class="form-control form-control-sm" [attr.aria-label]="strings.timeLabel" [(ngModel)]="scheduleTime">
              <button type="button" class="btn btn-primary btn-sm" (click)="submitScheduleCustom()">{{ strings.scheduleConfirm }}</button>
            </div>
          </div>
        </div>
      </span>
      <button *ngIf="canRecord && !recording" type="button" class="chat-composer__send chat-composer__send--mic" [attr.aria-label]="strings.recordVoice"
        [ngbTooltip]="strings.recordVoice" container="body" (click)="startRecording()">
        <chat-icon name="mic" [size]="17"></chat-icon>
      </button>
      <button *ngIf="!canRecord || recording" type="submit" class="chat-composer__send" [class.chat-composer__send--note]="isNote"
        [attr.aria-label]="recording ? strings.sendRecording : strings.send" [attr.aria-busy]="sendingPulse" [disabled]="!canSend"
        [ngbTooltip]="recording ? strings.sendRecording : strings.send" container="body">
        <chat-icon *ngIf="!sendingPulse" name="send" [size]="16"></chat-icon>
        <span *ngIf="sendingPulse" class="chat-composer__spinner" aria-hidden="true"></span>
      </button>
    </form>
    <p class="chat-composer__hint" aria-hidden="true">{{ strings.sendHint }}</p>
    <p *ngIf="recordError" class="chat-composer__error" role="alert">{{ recordError }}</p>
  </div>
</div>
